import BackendClient from './backendClient';
import { identityConfigurations } from "../utils/config";

export const _getOTP = (otp) => BackendClient.get(`${identityConfigurations.baseUrl}otp/${otp}`, false);

export const _postOTP = (accountId, mediaId, code) => BackendClient.post(`${identityConfigurations.baseUrl}otp`, { "code": code, "accountId": accountId, "mediaId": mediaId }, false);

export const _deleteOTP = (otp) => BackendClient.delete(`${identityConfigurations.baseUrl}otp/${otp}`);